import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_84: FaireProductEntity = {
  token: "starter_collection_84",
  type: "product",
  name: "Rhubarb Pot Holders",
  brandName: "Hedley & Bennett",
  imageUrl:
    "https://cdn.faire.com/fastly/f52634318a981fa5be6fd0f3e391de4c7faffa8dafd7acad587887fa7eda6de7.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 35,
  msrpDollars: 70,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
